export default function getColumnsDetails(columns) {
  const displayColumns = {};
  columns.forEach((column) => (displayColumns[column.field] = column));
  return displayColumns;
}
